import { render, staticRenderFns } from "./ComplexProd.vue?vue&type=template&id=a142bbbc&scoped=true"
import script from "./ComplexProd.vue?vue&type=script&lang=js"
export * from "./ComplexProd.vue?vue&type=script&lang=js"
import style0 from "./ComplexProd.vue?vue&type=style&index=0&id=a142bbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a142bbbc",
  null
  
)

export default component.exports